import { api } from "../intreceptor/apiInterceptor";

export interface JobsiteCountResponse {
    totalJobsites: number;
    completed: number;
    inProgress: number;
    completionRate: number;
    inactiveJobSiteCount: number;
}

export interface WorkersPercentageResponse {
    province: string;
    percentages: {
        union: number;
        nonUnion: number;
        mixed: number;
    };
    totalWorkers: number;
    counts: {
        union: number;
        nonUnion: number;
        mixed: number;
    };
}

export interface ComparisonResponse {
    sector: string;
    industries?: {
        name: string;
        union: {
            count: number;
            percentage: number;
        };
        mixed: {
            count: number;
            percentage: number;
        };
        nonUnion: {
            count: number;
            percentage: number;
        };
    }[];
    union?: {
        count: number;
        percentage: number;
    };
    mixed?: {
        count: number;
        percentage: number;
    };
    nonUnion?: {
        count: number;
        percentage: number;
    };
}

export interface FundingResourceResponse {
    totalJobsites: number;
    resources: {
        name: string;
        count: number;
        percentage: number;
    }[];
}

export interface StagesResponse {
    sector: string;
    totalJobsites: number;
    stages: {
        started: {
            count: number;
            percentage: number;
        };
        preConstruction: {
            count: number;
            percentage: number;
        };
        siteServices: {
            count: number;
            percentage: number;
        };
        buildingShell: {
            count: number;
            percentage: number;
        };
        roughIn: {
            count: number;
            percentage: number;
        };
        finishWork: {
            count: number;
            percentage: number;
        };
        projectCompleted: {
            count: number;
            percentage: number;
        };
    };
}


export interface WorkerTypeStatisticsResponse {
    totalJobsites: number;
    resources: {
        name: string;
        count: number;
        percentage: number;
    }[];
}

export const DashboardService = {
    async getJobsiteCount(timeRange: string): Promise<JobsiteCountResponse> {
        return api.fetch(`/dashboard/jobsite-counts?timeRange=${encodeURIComponent(timeRange)}`, {
            method: 'GET'
        });
    },

    async getWorkersPercentage(timeRange: string): Promise<WorkersPercentageResponse> {
        return api.fetch(`/dashboard/workers-percentage-by-province?timeRange=${encodeURIComponent(timeRange)}`, {
            method: 'GET'
        });
    },

    async getComparison(timeRange: string): Promise<ComparisonResponse[]> {
        return api.fetch(`/dashboard/jobsite-comparison?timeRange=${encodeURIComponent(timeRange)}`, {
            method: 'GET'
        });
    },

    async fundingResources(timeRange: string): Promise<FundingResourceResponse> {
        return api.fetch(`/dashboard/funding-resources-percentage?timeRange=${encodeURIComponent(timeRange)}`, {
            method: 'GET'
        });
    },

    async getCompletionStages(timeRange: string): Promise<StagesResponse[]> {
        return api.fetch(`/dashboard/completion-stages?timeRange=${encodeURIComponent(timeRange)}`, {
            method: 'GET'
        });
    },


    async getWorkerTypeStatistics(timeRange: string): Promise<WorkerTypeStatisticsResponse> {
        return api.fetch(`/dashboard/worker-type-statistics?timeRange=${encodeURIComponent(timeRange)}`, {
            method: 'GET'
        });
    }
}; 